// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"faf36ef6","204":"faf36ef6","591":"d91b89f7","688":"faf36ef6","824":"564279c4"}[chunkId] + ".chunk.css";
};